import LazySelect from "components/common/Select/LazySelect";
import { ACTION_STATES } from "core/actions";
import log from "loglevel";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import actions from "./logic/actions";

class CompanySelect extends React.Component {
    static defaultProps = {
        placeholder: "All Companies",
    };
    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultValue ? props.defaultValue : props.multiple ? [] : null,
        };
        this.onChange = this.onChange.bind(this);
    }
    onChange(value) {
        log.debug("companySelect", value);
        this.setState({ value }, () => {
            this.props.onChange(this.state.value);
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
    }

    render() {
        const { value } = this.state;

        const { filmCompanies, filmCompaniesStatus, multiple, placeholder, disabled } = this.props;
        const isLoading = filmCompaniesStatus === ACTION_STATES.SEND;
        const data = filmCompanies.map((cTitle) => ({
            value: cTitle.id,
            label: cTitle.title,
            contacts: cTitle.contacts,
            addresses: cTitle.addresses,
        }));
        return (
            <LazySelect
                onLoad={this.props.onLoadCompanies}
                onChange={this.onChange}
                data={data}
                value={value}
                multiple={multiple}
                defaultMenuPortalTarget
                loading={isLoading}
                placeholder={placeholder}
                disabled={disabled}
            />
        );
    }
}

CompanySelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onLoadCompanies: PropTypes.func.isRequired,
    filmCompanies: PropTypes.arrayOf(PropTypes.object).isRequired,
    filmCompaniesStatus: PropTypes.string.isRequired,
};

export default connect(
    ({ globalApp }) => ({
        filmCompanies: globalApp.filmCompanies,
        filmCompaniesStatus: globalApp.filmCompaniesStatus,
    }),
    (dispatch) => ({
        onLoadCompanies: (str) => dispatch(actions.GET_COMPANIES_TITLE.send(str)),
    })
)(CompanySelect);
